import { formatIconName } from '../jdsicon/logic';

export interface SelectorItemProps {
  value: string;
  label: string;
  icon?: JSX.Element;
  iconOnly?: boolean;
  id?: string;
  defaultChecked?: boolean;
  check?: boolean;
}

interface InternalSelectorItemProps extends SelectorItemProps {
  selectedIndex: number;
  internalIndex: number;
}

export const withLogic =
  (
    Component: React.ComponentType<InternalSelectorItemProps>
  ): React.FC<InternalSelectorItemProps> =>
  (props: InternalSelectorItemProps) => {
    return (
      <Component
        {...{
          ...props,
          selected: props.check || props.selectedIndex === props.internalIndex,
          iconAriaLabel:
            props.iconAriaLabel ||
            formatIconName(props.icon as unknown as string)
        }}
      />
    );
  };
